import { f as filterProps } from './utils-C5QdPtcV-A5kGtUmj.js';
import { a as IntlFormatError } from './error-CcshV7Gp-MfHpjqUW.js';
import { F as FormatError, E as ErrorCode } from '../../../../intl-messageformat/lib/src/error--j6_GWFu-BYuKgW-6.js';

var DISPLAY_NAMES_OPTONS = ['style', 'type', 'fallback', 'languageDisplay'];
function formatDisplayName(_a, getDisplayNames, value, options) {
  var locale = _a.locale,
    onError = _a.onError;
  var DisplayNames = Intl.DisplayNames;
  if (!DisplayNames) {
    onError(new FormatError("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", ErrorCode.MISSING_INTL_API));
  }
  var filteredOptions = filterProps(options, DISPLAY_NAMES_OPTONS);
  try {
    return getDisplayNames(locale, filteredOptions).of(value);
  } catch (e) {
    onError(new IntlFormatError('Error formatting display name.', locale, e));
  }
}

export { formatDisplayName as f };
//# sourceMappingURL=displayName-Du8XknBO-CTGMNGWe.js.map
